module.exports = __webpack_public_path__ + "media/images/icons/flags/JM-1a9d541ceedcd079342d251dcfa96c51.svg";